var map = {
	"./de.js": [
		"BpkI",
		5
	],
	"./en.js": [
		"AkSj",
		6
	],
	"./fr.js": [
		"UHev",
		7
	],
	"./it.js": [
		"PeP/",
		8
	],
	"./ja.js": [
		"LPye",
		9
	],
	"./ru.js": [
		"sR4o",
		10
	],
	"./tr.js": [
		"r799",
		11
	],
	"./zh.js": [
		"YJMR",
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "PKrk";
module.exports = webpackAsyncContext;